<template>
    <section class="gh-section learning-modes" id="learning-modes">
        <div class="container">
            <h3 class="gh-section__heading">Learning Modes</h3>
            <p class="gh-section__subheading">
                We combine text-based and video-based learning with real-time and on‑demand access to make your learning experience accessible and rewarding.
            </p>
            <div class="learning-modes__listing row">
                <div v-for="(item, index) in modes"
                    :key="index"
                    class="gh-item col-12 col-md-6">
                    <div class="lm__content">
                        <img :src="'/images/app/' + item.icon" :alt="item.heading" width="30">
                        <p class="lm__heading">{{ item.heading }}</p>
                        <div class="lm__body" v-html="item.body"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        computed: {
            modes () {
                return [
                    {
                        heading: 'Text Courses',
                        body: `Developed by MHA’s education team, our courses are developed specifically for your professional development. They’re referenced from a range of textbooks, peer-reviewed journal articles, selected websites and reputable sources.`,
                        icon: 'lm-text-courses.svg'
                    },
                    {
                        heading: `Video Courses`,
                        body: `Presented by mental health experts from all over the world, MHA’s video courses include webinar, conference and workshop recordings, role-play and real therapy in-session demonstrations, specialised videos series, and more.`,
                        icon: 'lm-video-courses.svg'
                    },
                    {
                        heading: `MHA Collections`,
                        body: `Looking for specialised learning? Our academic team hand-picks courses exploring a common topic, grouping them into “MHA Collections.” With a single click you can add an entire collection to your course list and fast-track your learning in that area.`,
                        icon: 'lm-mha-collections.svg'
                    },
                    {
                        heading: `Live Masterclasses`,
                        body: `MHA members receive complimentary access to live, interactive Masterclasses facilitated by experienced clinicians and educators. Each Masterclass includes 4 hours of live learning and is supported by a range of clinical and educational resources.`,
                        icon: 'lm-mha-masterclass.png'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .learning-modes {
        color: #005A46;
        background-color: #F9F6F1;
        &__listing {
            margin-top: 2rem;
        }

        &__cta {
            margin-top: 2rem;
            text-align: center;
        }

        .lm {
            text-align: center;

            + .lm {
                margin-top: 2rem;
            }

            &__body {
                text-align: left;
                font-size: 1.2rem;
            }

            &__icon {
                max-width: 80px;
                margin: 0 auto;
            }

            &__heading {
                margin-bottom: .5rem;
                font-weight: 700;
                font-size: 1.5rem;
            }
        }
    }

    .learning-modes__listing {
        max-width: 900px;
        width: 100%;
        margin: 0 auto;
        margin-bottom: -3rem;
        margin-top: 1rem;
        .lm {
            font-weight: 500;
        }

        .lm__body {
            line-height: 1.5;
        }

        .gh-item {
            margin-bottom: 3rem;
        }

        img {
            width: 30px;
            height: auto;
            margin-bottom: 1rem;
        }
    }

    .gh-section__subheading {
        max-width: 750px;
        margin: auto;
        text-align: center !important;
    }
    @media screen and (max-width: '1023px') {
      .lm__content {
        justify-content: center;
        display: flex;
        flex-flow: column;
        align-items: center;
        padding: 0 2rem;
      }

      .lm__body {
        text-align: center !important;
      }
    }

</style>